import { ArmyList, ArmyListUnit, UnitOptionGroup } from '@Models';
import { OptionActivation } from './optionActivation';
import { checkConstrainedObjectHidden } from '@Selectors/builder/myArmyList/make/unit/edit/selector/optionIsActive';

export const optionGroupIsActive = (
  optionGroup: UnitOptionGroup,
  armyList: ArmyList,
  armyListUnit: ArmyListUnit,
): boolean => {
  return (
    checkConstrainedObjectHidden(optionGroup, armyList, armyListUnit)
      .filter((item) => item != OptionActivation.UNKNOW)
      .map((item) => item === OptionActivation.ACTIVE)
      .reduce((a, b) => a && b, true) ?? true
  );
};
